"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefinementsLoadingSelector = exports.useRefinementsDataSelector = exports.useRefinementsFilterSelector = void 0;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const main_1 = require("./main");
const refinementsFilterSelector = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ refinements }) => refinements.refinementsFilter);
const useRefinementsFilterSelector = () => (0, react_redux_1.useSelector)(refinementsFilterSelector);
exports.useRefinementsFilterSelector = useRefinementsFilterSelector;
const refinementsDataSelector = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ refinements }) => refinements.data);
const useRefinementsDataSelector = () => (0, react_redux_1.useSelector)(refinementsDataSelector);
exports.useRefinementsDataSelector = useRefinementsDataSelector;
const refinementsLoadingSelector = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ refinements }) => refinements.isLoading);
const useRefinementsLoadingSelector = () => (0, react_redux_1.useSelector)(refinementsLoadingSelector);
exports.useRefinementsLoadingSelector = useRefinementsLoadingSelector;
